import { render, staticRenderFns } from "./DiscoveryStatsChartSource.vue?vue&type=template&id=42b83c72"
import script from "./DiscoveryStatsChartSource.vue?vue&type=script&lang=js"
export * from "./DiscoveryStatsChartSource.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryStatsChartSource.vue?vue&type=style&index=0&id=42b83c72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports